import React, { useEffect, useState } from "react";
import pt from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Search from "@material-ui/icons/Search";
import Icon from "@material-ui/core/Icon";
import Pagination from '@material-ui/lab/Pagination';

// core components
import useAuth from "hooks/useAuth";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { formatDateFilterNew } from "services/formatDate";
import ModalAddDebits from "components/ModalAddDebits/ModalAddDebits";
import ModalUpdateDebits from "components/ModalUpdateDebits/ModalUpdateDebits";
import ModalDeleteDebits from "components/ModalDeleteDebits/ModalDeleteDebits";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  colorCard: {
    color: "#999",
  },
  floatRight: {
    float: "right",
  },
  maxwidht: {
    maxWidth: "107%",
  },
  toogleclass: {
    marginTop: "14px",
    marginBottom: "14px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50",
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)",
  },
  zindex: {
    zIndex: "0 !important",
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px",
  },
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);

export default function Debit() {
  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const { storageId } = useAuth();
  const classes = useStyles();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const types = [{ id: "", description: "TODOS" }, { id: "D", description: "D" }, { id: "C", description: "C" }];

  const [search, setSearch] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowUpdate, setModalShowUpdate] = useState(false);
  const [modalShowDelete, setModalShowDelete] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [debit, setDebit] = useState([]);
  const [index, setIndex] = useState({ id: 1 });

  const [id_analytical, setId_analytical] = useState("");
  const [analytical, setAnalytical] = useState([{ id: "", code: 0, description: "TODOS" }]);
  const [id_subsynthetic, setId_subsynthetic] = useState("");
  const [subsynthetic, setSubsynthetic] = useState([{ id: "", code: 0, description: "TODOS" }]);
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    getAllAnalyticals();
    getAllSubsynthetic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAllDebit();
  }, [type, id_analytical, id_subsynthetic, search, startDate, endDate, page]);

  const loadModal = async () => {
    setImportModal(true);
  }

  function callModalAdd() {
    if (!modalShow) {
      loadModal();
    }
    setModalShow(true);
  }

  function callModal(index) {
    if (!modalShowUpdate) {
      loadModal();
    }
    setIndex(index);
    setModalShowUpdate(true);
  }

  function callModalDelete(index) {
    if (!modalShowDelete) {
      loadModal();
    }
    setIndex(index);
    setModalShowDelete(true);
  }

  async function getAllDebit() {
    try {

      const response = await api.get(
        `/debit/all?id_admin=${storageId}&page=${page}&perPage=${perPage}&id_analytical=${id_analytical}&id_subsynthetic=${id_subsynthetic}&type=${type}&description=${search}&startDate=${formatDateFilterNew(startDate)}&endDate=${formatDateFilterNew(endDate)}`
      );
      setTotalPages(response.data.totalPage)
      setDebit(response.data.debit);

    } catch (error) {
      alert("erro: " + error);
    }
  }

  async function getAllAnalyticals() {
    const response = await api.get("/subsynthetic/all?id_admin=" + storageId);

    const ressubsynthetic = response.data
    for (let i = 0; i < ressubsynthetic.length; i++) {
      setSubsynthetic(subsynthetic => [...subsynthetic, response.data[i]])
    }
  }

  async function getAllSubsynthetic() {
    const response = await api.get("/Analytical/all?id_admin=" + storageId);

    const resAnalytical = response.data
    for (let i = 0; i < resAnalytical.length; i++) {
      setAnalytical(analytical => [...analytical, response.data[i]])
    }
  }

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function downloadReport() {
    if (!startDate || !endDate) {
      return alert('Datas invalidas');
    }
    await api
      .get(`/debit/report?id_admin=${storageId}&init_date=${formatDateFilterNew(startDate)}&end_date=${formatDateFilterNew(endDate)}`, {
        responseType: "blob",
      })
      .then(function (response) {
        let blob = new Blob([response.data], {
          responseType: "arraybuffer",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/pdf",
          },
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        switch (storageId) {
          case 3:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} RJ.xlsx`;
            break;
          case 6:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} GO.xlsx`;
            break;
          case 7:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} PR.xlsx`;
            break;
          case 8:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} BA.xlsx`;
            break;
          case 9:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} AP.xlsx`;
            break;
          case 8:
            link.download = `Relatório debito ${formatDateFilterNew(startDate)}_${formatDateFilterNew(endDate)} SP.xlsx`;
            break;
          default:
            break;
        }
        link.click();
      }).catch(function (error) {
        console.log(error);
      });
  }

  function getDebitsForTable() {
    let teste = [];

    for (let i = 0; i < debit.length; i++) {
      teste[i] = [];
      teste[i].push(formatDateFilterNew(debit[i].date_of_debit));
      teste[i].push(debit[i].description);
      teste[i].push(debit[i].value);
      teste[i].push(debit[i].analytical_code + " - " + debit[i].analytical_description);
      teste[i].push(debit[i].type);
      if (debit[i].type === "D") {
        teste[i].push(
          <div className={classes2.tableActions}>
            <Tooltip
              id="tooltip-top"
              title="Editar"
              placement="top"
              classes={{ tooltip: classes2.tooltip }}
            >
              <IconButton
                aria-label="Edit"
                className={classes2.tableActionButton}
                onClick={() => callModal(debit[i])}
              >
                <Edit
                  className={classes2.tableActionButtonIcon + " " + classes2.edit}
                />
              </IconButton>
            </Tooltip>
            <Tooltip
              id="tooltip-top-start"
              title="Deletar"
              placement="top"
              classes={{ tooltip: classes2.tooltip }}
            >
              <IconButton
                aria-label="Close"
                className={classes2.tableActionButton}
                onClick={() => callModalDelete(debit[i])}
              >
                <Close
                  className={
                    classes2.tableActionButtonIcon + " " + classes2.close
                  }
                />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    }

    return teste;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader
              className="d-flex justify-content-center zindex"
              color="warning"
              stats
              icon
            >
              <CardIcon color="success">
                <Icon>content_copy</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardFooter className="d-flex justify-content-center" stats>
            <Button
              color="success"
              className={classes.margintp + " " + classes.maxwidht}
              onClick={() => callModalAdd()}
            >
              Adicionar lançamento
            </Button>
          </CardFooter>
          <CardFooter className="d-flex justify-content-center" stats>
            <Button
              color="info"
              className={classes.margintp + " " + classes.maxwidht}
              onClick={() => downloadReport()}
            >
              Gerar Relatorio
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>today</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data primária</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={startDate}
              onChange={date => setStartDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>event</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data final</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center " stats>
            <DatePicker className={classes.marginDate}
              selected={endDate}
              onChange={date => setEndDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader
              className="d-flex justify-content-center zindex"
              color="warning"
              stats
              icon
            >
              <CardIcon color="warning">
                <Icon>data_usage</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>
              Clique abaixo para filtrar por analítico
            </p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Form.Control
              onChange={(event) => setId_analytical(event.target.value)}
              value={id_analytical}
              as="select"
              defaultValue="Choose..."
            >
              {analytical.map((analytic) => (
                <option key={String(analytic.id)} value={analytic.id}>
                  {analytic.code} - {analytic.description}
                </option>
              ))}
            </Form.Control>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader
              className="d-flex justify-content-center zindex"
              color="warning"
              stats
              icon
            >
              <CardIcon color="warning">
                <Icon>data_usage</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>
              Clique abaixo para filtrar por sub-sintetico
            </p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Form.Control
              onChange={(event) => setId_subsynthetic(event.target.value)}
              value={id_subsynthetic}
              as="select"
              defaultValue="Choose..."
            >
              {subsynthetic.map((subsynthetic) => (
                <option key={String(subsynthetic.id)} value={subsynthetic.id}>
                  {subsynthetic.code} - {subsynthetic.description}
                </option>
              ))}
            </Form.Control>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader
              className="d-flex justify-content-center zindex"
              color="warning"
              stats
              icon
            >
              <CardIcon color="warning">
                <Icon>data_usage</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>
              Clique abaixo para filtrar por tipo
            </p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Form.Control
              onChange={(event) => setType(event.target.value)}
              value={type}
              as="select"
              defaultValue="Choose..."
            >
              {types.map((type) => (
                <option key={String(type.id)} value={type.id}>
                  {type.description}
                </option>
              ))}
            </Form.Control>
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes3.searchWrapper}>
          <CustomInput
            formControlProps={{
              className: classes3.margin + " " + classes3.search,
            }}
            inputProps={{
              placeholder: "Busca por descrição",
              inputProps: {
                "aria-label": "Search",
                type: "text",
                value: search,
                onChange: (event) => setSearch(event.target.value),
              },
            }}
          />
          <Button color="white" aria-label="edit" justIcon round>
            <Search />
          </Button>
        </div>
      </GridItem>
      <Card>
        <CardHeader className={classes.zindex} color={"primary"}>
          <h4 className={classes.cardTitleWhite}>
            Lançamentos de débitos destinados a operação
          </h4>
          <p className={classes.cardCategoryWhite}></p>
        </CardHeader>
        <CardBody>
          <Table
            index={index}
            tableHeaderColor="primary"
            tableHead={["Data", "Descrição", "Valor", "Analítico", "Tipo", "Ações"]}
            tableData={getDebitsForTable()}
          />
        </CardBody>
      </Card>
      <Pagination count={totalPages} page={page} onChange={handleChange} />

      {importModal && modalShow && (
        <ModalAddDebits
          key={String("Add_" + index.id)}
          props={index}
          show={modalShow}
          onHide={() => setModalShow(false)}
          getAllDebit={getAllDebit}
        />
      )}
      {importModal && modalShowUpdate && (
        <ModalUpdateDebits
          key={String("Upd_" + index.id)}
          props={index}
          show={modalShowUpdate}
          onHide={() => setModalShowUpdate(false)}
          getAllDebit={getAllDebit}
        />
      )}
      {importModal && modalShowDelete && (
        <ModalDeleteDebits
          key={String("Upd_" + index.id)}
          props={index}
          show={modalShowDelete}
          onHide={() => setModalShowDelete(false)}
          getAllDebit={getAllDebit}
        />
      )}

    </GridContainer>
  );
}
